import { apiFetch } from "@/lib/api/client";
import type { NotificationEntry } from "@/lib/types/session";

export function getNotifications(): Promise<NotificationEntry[]> {
  return apiFetch("/notifications");
}

export function markNotificationRead(id: string): Promise<{ ok: true; readAt: string }> {
  return apiFetch(`/notifications/${id}/read`, { method: "POST" });
}

export function markAllNotificationsRead(): Promise<{ ok: true }> {
  return apiFetch("/notifications/read-all", { method: "POST" });
}
